import { render } from "./HowToAgentGroup.vue?vue&type=template&id=7732014e"
import script from "./HowToAgentGroup.vue?vue&type=script&lang=js"
export * from "./HowToAgentGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__